import { loadUserFromAccelerate } from 'actions/user';
import config from 'config';
import React from 'react';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';

export const Accelerate = ({ location, history }) => {
    const dispatch = useDispatch();

    const [email, setEmail] = React.useState(null);
    const [tenant, setTenant] = React.useState(null);
    const [redirect, setRedirect] = React.useState(null);
    const { user } = useSelector(state => state.user);

    React.useEffect(() => {
        const values = queryString.parse(location.search);
        setEmail(values.email);
        setTenant(values.tenant);
        setRedirect(values.redirect || '/');
    }, []);

    React.useEffect(() => {
        if (email && tenant && !user) {
            dispatch(loadUserFromAccelerate(history, email, tenant));
        }
    }, [email, tenant, user]);

    React.useEffect(() => {
        if (user?.id && redirect) {
            history.push(redirect.replace(config.url, ''));
        }
    }, [user, redirect]);

    return (
        <div className="flex flex-center flex-column">
            <h3>Redirecting from Accelerate...</h3>
            <div>
                <i className="fa fa-spin fa-cog text-lg mr10" />
                Please Wait
            </div>
        </div>
    );
};

export default withRouter(Accelerate);
